// One place for the names and colours used across the app, so every screen
// and browser tab says the same thing. Matches the Home portal's brand.js.
export const BANK_NAME = "Asokore Community Bank PLC";
export const APP_NAME = "Reconciliation";

export const colors = {
  primary: "#21313c",
  primaryLight: "#304753",
  primaryDark: "#19262f",
  secondary: "#17b859",
  secondaryDark: "#109347",
  secondarySoft: "rgba(23,184,89,0.12)",
  background: "#f6f8fa",
  surface: "#ffffff",
  surfaceSoft: "#f8fafc",
  border: "#e4e9ee",
  textPrimary: "#21313c",
  textSecondary: "#667085",
  danger: "#d32f2f",
  dangerDark: "#b71c1c",
  dangerSoft: "rgba(211,47,47,0.08)",
  warning: "#b45309",
  warningSoft: "rgba(255, 193, 7, 0.12)",
};

export const SIDEBAR_WIDTH = 220;
export const HEADER_HEIGHT = 60;
